import _uniqBy from 'lodash/uniqBy';
import {
  apiPost,
  apiStore,
  generateFormData,
} from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  async ReportMentor(context, { mentor, reason }) {
    // xhr post
    const Mentor = context.commit('getMentor', mentor.id);
    console.log(Mentor, reason);

    context.commit('updateMentor', {
      id: mentor.id,
      prop: 'reported',
      value: true,
    });
    return true;
  },

  async getMyMentors(context, refresh = false) {
    const myMentors = await apiStore.getItem('mymentors') || context.state.mentors;

    if (myMentors) {
      myMentors.forEach((mentor) => {
        context.commit('addMentor', mentor);
      });
    }

    const formData = new FormData();
    formData.set('mentee', context.rootState.User.id);

    // still fetch then update
    const response = apiPost('matched_mentee', formData, 1)
      .then(async (res) => {
        if (!res) return [];
        if (toBoolean(res.data.error)) return [];

        const mentors = res.data.matched_mentee;

        await mentors.forEach(async (mentor) => {
          context.dispatch('getUserData', mentor.mentorid)
            .then(async (u) => {
              if (u) {
                const user = { ...u };
                await context.commit('addMentor', { ...mentor, user });
              }
            });
        });

        return mentors;
      });

    if (!refresh) return myMentors;

    return response;
  },

  // [WAITING FOR MATCH ADVANCED UPDATE]
  // eslint-disable-next-line no-unused-vars
  async findMentors(context, { genders = [1, 2], goals, groupid = undefined }) {
    const mentee = await context.dispatch('getUserData', context.rootState.User.id);
    const groupId = groupid || context.getters.menteeGoalGroupId;
    if (!groupId || !mentee) return false;

    /**
     * goals: {Array}                     // chosen goals // [UPDATE V2]
     * groupid: {id}                      // pillar group id
     * gender: {id|Array|Stringed Array}  // male(1), female(2)
     * check: {Number}                    // check for both genders
     */
    const formData = generateFormData({
      // goals,
      // gender: JSON.stringify(genders),
      groupid: groupId,
      gender: genders[0],
      check: ((genders.length > 1) ? 1 : 0),
      mentee: context.rootState.User.id,
    });

    const results = await apiPost('suggestions_filter', formData, 1)
      .catch(() => [])
      // .catch(() => {
      //   apiStore.removeItem('UserViewData/findmentors');
      //   return [];
      // })
      .then((res) => {
        if (!res) return [];
        if (toBoolean(res.data.error)) return [];
        return res.data.Mentors_available;
      });

    if (results.length > 0) {
      // make sure there are no duplicates
      await apiStore.setItem('UserViewData/findmentors', _uniqBy(results, 'mentorid'));
      return results;
    }

    await apiStore.removeItem('UserViewData/findmentors');

    return results;
  },

  // [WAITING FOR MATCH ADVANCED UPDATE]
  async newMentorsRequestList(context) {
    const mentors = await context.dispatch('findMentors', {
      genders: [1, 2],
      goals: undefined,
      groupid: undefined,
    });
    // const mentors = await apiStore.getItem('UserViewData/findmentors') || [];
    const requests = [];

    mentors.forEach((mentor) => {
      requests.push(context.dispatch('getUserData', mentor.mentorid));
    });

    const mentorsInfos = await Promise.all(requests)
      .then((responses) => {
        if (!responses) return [];

        return responses;
      });

    return mentorsInfos;
  },

  async sendMentorRequest(context, mentorid) {
    const mentors = await apiStore.getItem('UserViewData/findmentors') || [];
    const mentor = mentors.find(m => m.mentorid === mentorid);
    if (!mentor) return [false, 'Mentor not found'];

    const formData = generateFormData({
      mentor: mentorid,
      mentee: context.rootState.User.id,
      groupid: mentor.groupid,
    });

    const response = await apiPost('match_request', formData, 1)
      .then((res) => {
        if (!res) return [false, res.data.message];
        if (toBoolean(res.data.error)) return [false, res.data.message];
        return [true];
      });

    return response;
  },
};
